import React from 'react'

function YoutubeUrlComponent(props) {
  const { selectedListType, dataItem, editIndexes, getURl, dataIndex, PushVideo } = props
  return (
    <div>
      {selectedListType === 'Text' && (
        <div style={{ display: 'flex', gap: '1rem' }}>
          <input
            className='form-control'
            style={{ width: '88%' }}
            type={'url'}
            value={dataItem && dataItem.tempUrl ? dataItem.tempUrl : ''}
            disabled={
              !(
                editIndexes.includes(dataItem.SK) &&
                dataItem.listItemDescription &&
                dataItem.listItemDescription_Te
              )
            }
            onChange={e => getURl(e, dataIndex)}
            // youtubeUrl(e, dataIndex)
          />
          {dataItem.tempUrl && dataItem.tempUrl.length > 7 && (
            <button className='btn btn-primary' type='button' onClick={() => PushVideo(dataIndex)}>
              ok
            </button>
          )}
        </div>
      )}
      {selectedListType !== 'Text' && !dataItem.youtubeEmbedLink && (
        <div style={{ display: 'flex', gap: '1rem' }}>
          <input
            className='form-control'
            style={{ width: '88%' }}
            type={'url'}
            value={dataItem && dataItem.tempUrl ? dataItem.tempUrl : ''}
            disabled={!editIndexes.includes(dataItem.SK)}
            onChange={e => getURl(e, dataIndex)}
            // youtubeUrl(e, dataIndex)
          />
          {dataItem.tempUrl && dataItem.tempUrl.length > 7 && (
            <button
              className='btn btn-primary'
              type='button'
              onClick={() => PushVideo(dataIndex)}
              disabled={!editIndexes.includes(dataItem.SK)}
            >
              ok
            </button>
          )}
        </div>
      )}
    </div>
  )
}

export default YoutubeUrlComponent
